import { render, staticRenderFns } from "./DialogShareMultiMessage.vue?vue&type=template&id=3242f084"
import script from "./DialogShareMultiMessage.vue?vue&type=script&lang=js"
export * from "./DialogShareMultiMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports